export default {
  screens: [
    {
      type: 'intro',
      title: 'メゾンショーメ',
      content:
        '1812年、ショーメはヴァンドーム広場の、現在リッツがある場所に拠を構えた最初のジュエラーとなりました。パリのジュエラーの誕生です。',
      idYt: 'Ksm_iOCcZVE',
      videoCover: 'world/home/video.jpg',
      desktop: {
        cover: 'world/home/cover-1.jpg'
      },
      mobile: {
        cover: 'world/home/mobile-cover-1.jpg',
        contentStyle: { width: '90%' },
        coverStyle: {
          width: '60%',
          bottom: '-30%',
          right: '0',
          left: 'inherit',
          position: 'absolute'
        }
      }
    },
    {
      type: 'perspective',
      leftImg: 'world/home/perspectiveLeft.jpg',
      middleImg: 'world/home/perspectiveMiddle.jpg',
      content:
        'ショーメがヴァンドーム広場12番地の現在の場所に移ったのは、1907年のことです。この個人邸宅には、歴史あるブティック、歴史的建造物に指定されたサロン、クリエーションスタジオ、ハイジュエリー制作のためのアトリエが置かれています。',
      cover: 'world/home/cover-2.jpg'
    },
    {
      type: 'shadow',
      desktop: {
        middleImg: 'world/home/shadowMiddle.jpg',
        leftImg: 'world/home/shadowLeft.jpg',
        cover: 'world/home/cover-3.jpg'
      },
      mobile: {
        middleImg: 'world/home/shadowMiddle.jpg',
        leftImg: 'world/home/shadowLeft.jpg',
        cover: 'world/home/mobile-cover-3.jpg',
        coverStyle: {
          width: '79%',
          bottom: '-27%',
          right: '-4%',
          left: 'inherit',
          position: 'absolute'
        }
      },
      content:
        '威信あるこの場所には、ショーメの輝かしい歴史が刻まれています。<br><br> メゾンの創業者であり創造性と革新性に溢れたマリ=エティエンヌ・ニトは、自らの卓越したサヴォワールフェールを後継者たちに伝えました。'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/locales/jp/worlds/home.js